import { objectOf, arrayOf, anyOf } from "@altostra/type-validations";
import { string, number, nullValidation, maybeString } from "@altostra/type-validations/lib/primitives";

const nullableString = anyOf(maybeString, nullValidation);

export const isSendOutcomesAbortLogDataResult = objectOf({
  hits: number,
  results: arrayOf(
    objectOf({
      id: string,
      time: string,
      user_id: nullableString,
      canvas_step_name: nullableString,
      outcome: string,
      channel: nullableString,
      canvas_step_id: nullableString,
    })
  ),
});
